import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import bootcampStyle from '~/shared/styles/BootcampSanityBlock.module.css'

import { BlockContent } from '~/components'

import { Task, TaskStatus } from '../types/OrderElements.types'

interface Props {
  task: Task
}

function TaskCard({ task }: Props): React.ReactElement {
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
    id: task.id,
    data: {
      type: 'Task',
      task,
    },
    disabled: task.check,
  })

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  }

  if (isDragging) {
    return (
      <div
        className="opacity-30 bg-mainBackgroundColor rounded -ml-1 -mt-1 border-4 h-24 w-18 md:w-24 flex"
        onTouchMove={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        ref={setNodeRef}
        style={style}
      />
    )
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={getBackgroundStyle()}
      onTouchMove={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <div className={`text-white text-center w-full tracking-tight ${bootcampStyle['task-content']}`}>
        <BlockContent blocks={task.content} />
      </div>
    </div>
  )

  function getBackgroundStyle(): string {
    const def =
      'rounded -ml-1 -mt-1 border-purple border-4 h-18 md:h-24 w-18 md:w-24 flex text-center  items-center cursor-grab touch-action-none'

    if (task.check) {
      task.taskStatus =
        task.categoryName === 'answer' && task.position === task.id ? TaskStatus.Right : TaskStatus.Wrong
      return task.taskStatus === TaskStatus.Right
        ? `bg-green-checkmark border-green-moderate-dark ${def} `
        : `bg-red-error border-red-dark ${def} `
    } else {
      return `bg-gradient-purple-dark-top ${def} `
    }
  }
}

export default TaskCard
